import { initDetailControls } from './detail-controls';
import { mountSearchDropdown } from './islands/SearchDropdown';
import { initItemDetailViewTracking } from './item-detail-view';
import { initRecentlyViewedRecorder } from './recently-viewed';
import { initRelatedItemClickTracking } from './related-item-click';
import { initScrollHeader } from './scroll-header';
import { initShareActions } from './share-actions';
import { initShopClickTracking } from './shop-click';
import { initStickyCta } from './sticky-cta';
import { initYoutubePlayer } from './youtube-player';

const boot = () => {
  initScrollHeader();
  initDetailControls();

  if (document.getElementById('search-input')) {
    mountSearchDropdown();
  }

  if (document.querySelector('[data-share-copy]')) {
    initShareActions();
  }

  if (document.querySelector('[data-sticky-cta]')) {
    initStickyCta();
  }

  if (document.querySelector('[data-shop-click]')) {
    initShopClickTracking();
  }

  if (document.querySelector('[data-item-detail-view]')) {
    initItemDetailViewTracking();
  }

  if (document.querySelector('[data-related-item-placement]')) {
    initRelatedItemClickTracking();
  }

  if (document.querySelector('iframe[data-youtube-id]')) {
    initYoutubePlayer();
  }

  if (document.querySelector('[data-recently-viewed-record]')) {
    initRecentlyViewedRecorder();
  }
};

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot, { once: true }) : boot();
